/**
 * Copyright (C) Siemens AG 1996-2026 ALL RIGHTS RESERVED.
 */

import {Component, inject} from '@angular/core';
import {IxActiveModal} from '@siemens/ix-angular';
import {MasterChildStringEnum} from '../../../../models/Passport';

@Component({
  selector: 'app-remove-passport-modal',
  standalone: false,
  templateUrl: './remove-passport-modal.component.html',
  styleUrl: './remove-passport-modal.component.scss',
})
export class RemovePassportModalComponent {
  readonly activeModal = inject(IxActiveModal);

  protected readonly MasterChildStringEnum = MasterChildStringEnum;
}
